import {
  EMPTY_STRING,
  STATS_SCREEN_CONSTANTS,
  storeConstants,
} from "../constants";
import {
  postRequest,
  getRequest,
  deleteRequest,
  putRequest,
  uploadLogoRequest,
  getZplCodeRequest,
  deleteRequestWithData,
} from "../system/serverCall";
import serverResponseHandler from "../system/serverResponseHandler";

//-------Get Store Details from server
const getStores = () => {
  return getRequest("store", true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Add store service
const addStore = (data) => {
  return postRequest("store", data, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Edit store service
const editStore = (data) => {
  return putRequest(`store/${data.id}`, data, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Store Details from server
const getStoreOwners = () => {
  return getRequest("get-users?role=store-owner", true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Delete Store from server
const deleteStore = (storeId) => {
  return deleteRequest(`store/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const uploadLogo = (data) => {
  return uploadLogoRequest("upload", data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateReceiptDetails = (id, data) => {
  return postRequest(`receipt-details/${id}?isUpdateLogo=true`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateStoreSettings = (id, data, macAddress) => {
  return postRequest(
    `receipt-details/${id}${macAddress ? `/${macAddress}` : ""}`,
    data
  ).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getUserNotifications = (storeId) => {
  return getRequest(`notification/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------payouts information
const getPayoutsInformation = (storeId, startDate, endDate) => {
  return getRequest(
    `at-a-glance/${storeId}?startDate=${startDate}&endDate=${endDate}&screenName=${STATS_SCREEN_CONSTANTS.FINANCE_STATS}`
  ).then(
    (response) => response.data.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
//-------mark notification as read

const markNotificationAsRead = (storeId, data) => {
  return putRequest(`notification/${storeId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const createNotification = (storeId, data) => {
  return postRequest(`notification/${storeId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const getCustomSalesTaxRules = (storeId) => {
  return getRequest(`store-budget/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const addSaleTax = (storeId, data, queryParams) => {
  return postRequest(
    `store-budget/${storeId}${queryParams ? `?${queryParams}` : EMPTY_STRING}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const deleteSaleTax = (storeId, taxRateId) => {
  return deleteRequest(`store-budget/${storeId}/${taxRateId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const editSaleTax = (ObjectDetail, data, queryParams) => {
  return putRequest(
    `store-budget/${ObjectDetail.storeId}${
      queryParams ? `?${queryParams}` : "?isDefaultTax=true"
    }`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStoreLogoZplCode = (data) => {
  return getZplCodeRequest("https://api.labelary.com/v1/graphics", data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Store Subscription payment
const getStripeCheckoutSession = (storeId) => {
  return putRequest(
    `store-subscription-payment/${storeId}?type=${storeConstants.GET_STRIPE_CHECKOUT_SESSION}`,
    true
  ).then(
    (response) => response.data.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStripeCustomerPortalSession = (storeId) => {
  return putRequest(
    `store-subscription-payment/${storeId}?type=${storeConstants.GET_STRIPE_CUSTOMER_PORTAL_SESSION}`,
    true
  ).then(
    (response) => response.data.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Cancel Store from server
const stripeCancelSubscription = (data) => {
  return deleteRequestWithData(
    `store-subscription-payment/${data.storeId}`,
    data,
    true
  ).then(
    (response) => response?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const addFreeMonths = (data) => {
  return putRequest(
    `store-subscription-payment/${data.storeId}?type=ADD_FREE_MONTHS`,
    data
  ).then(
    (response) => response?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const connectShopify = (data) => {
  return getRequest(
    `shopify?shop=${data.shop}&companyId=${data.companyId}&storeId=${data.storeId}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const triggerCustomerSyncWithShopify = (data) => {
  return putRequest(
    `shopify?type=TRIGGER_CUSTOMER_SYNC&storeId=${data.storeId}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStoreById = (storeId) => {
  return getRequest(`store/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStoreMiscData = (storeId, type) => {
  return getRequest(`store-misc-data/${storeId}/${type}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Export store Services
export const storeService = {
  addStore,
  getStores,
  editStore,
  uploadLogo,
  editSaleTax,
  deleteStore,
  getStoreById,
  getStoreOwners,
  connectShopify,
  createNotification,
  updateStoreSettings,
  getStoreLogoZplCode,
  updateReceiptDetails,
  getUserNotifications,
  getPayoutsInformation,
  markNotificationAsRead,
  stripeCancelSubscription,
  getStripeCheckoutSession,
  triggerCustomerSyncWithShopify,
  getStripeCustomerPortalSession,
  addFreeMonths,
  getCustomSalesTaxRules,
  addSaleTax,
  deleteSaleTax,
  getStoreMiscData,
};
